import { FileReader, FileWriter } from '@/platform'
class CustomUIFontStyle{
  public FontSize: number = 12; //字体大小
  public FontName: string = '' //字体名称
  public FontCor: string = '0,0,0' //字体颜色
  public X: number = 0 //字体图片x坐标
  public Y: number = 0 //字体图片y坐标

  constructor(
    param?:
      | { fot: number; fontName: string; cor: string; x: number; y: number }
      | FileReader
  ) {
    if (param && "fot" in param) {
      const {
        fot = 30,
        fontName = "黑体",
        cor = "0,0,0",
        x = 0,
        y = 0,
      } = param;
      this.FontSize = fot;
      this.FontName = fontName;
      this.FontCor = cor;
      this.X = x;
      this.Y = y;
    } else if (param instanceof FileReader) {
      var reader = (param as FileReader)
      this.FontSize = reader.readInt();
      this.FontName = reader.readString();
      this.FontCor = reader.readString();
      this.X = reader.readInt();
      this.Y = reader.readInt();
    } else {
      this.FontSize = 30;
      this.FontName = "黑体";
      this.FontCor = "0,0,0";
      this.X = 0;
      this.Y = 0;
    }
  }
}

export default CustomUIFontStyle;
